import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Grid2 } from "@mui/material";
import { MyLeaveBarNew } from "../bar-new";
import useStyles from "../leave-base-card/leave-base-card.style";
import { useMyLeaveSummaryChartData } from "my-leave/hooks";

interface MyLeaveBarDashboardProps {
  id: string;
  row: any; // Replace 'any' with a more specific type if available
}

export const MyLeaveBarDashboard: React.FC<MyLeaveBarDashboardProps> = ({
  id,
  row,
}) => {
  const { t } = useTranslation();
  let thisYear = new Date().getFullYear().toString();

  const { data, noLeave } = useMyLeaveSummaryChartData({
    year: thisYear,
    contract: row?.contract,
  });

  const classes = useStyles();

  /*
  let availableLeavePercentage = (
    (100 * Math.abs(data?.availableLeaveDays || 0)) /
    data?.allLeaveDays
  ).toFixed(2);

  let requestedLeavePercentage = (
    (100 * Math.abs(data?.requestedLeaveDays || 0)) /
    data?.allLeaveDays
  ).toFixed(2);

  let fulfilledLeavePercentage = (
    (100 * Math.abs(data?.fulfilledLeaveDays || 0)) /
    data?.allLeaveDays
  ).toFixed(2);
  */
  return (
    <Grid2
      size={{ xs: 12, sm: 6, md: 6, lg: 12 }}
      style={{
        borderRadius: 8,
        marginTop: 16,
      }}
    >
      <Box id={id} className={classes.leaveLineChart}>
        {!noLeave ? (
          <>
            <MyLeaveBarNew
              requestable={data.availableLeaveDays}
              fulfilled={data.fulfilledLeaveDays}
              requested={data.requestedLeaveDays}
              onlyBar
            />

            {/**
            <Box
              className={classes.leaveTooltipLeaveTitleLine}
              width={`${availableLeavePercentage}%`}
            >
              <Box
                className={
                  data?.requestedLeaveDays === 0 &&
                  data?.fulfilledLeaveDays === 0
                    ? classes.availableLeaveDaysEdited
                    : classes.availableLeaveDays
                }
              >
                {data?.availableLeaveDays?.toLocaleString()}
              </Box>
            </Box>
            <Box
              className={classes.leaveTooltipLeaveTitleLine}
              width={`${requestedLeavePercentage}%`}
            >
              <Box
                className={
                  data?.availableLeaveDays === 0 &&
                  data?.fulfilledLeaveDays === 0
                    ? classes.requestedLeaveDaysEditedTLTR
                    : data?.fulfilledLeaveDays === 0
                      ? classes.requestedLeaveDaysEditedTR
                      : data?.availableLeaveDays === 0
                        ? classes.requestedLeaveDaysEditedTL
                        : data?.requestedLeaveDays === 0
                          ? classes.fulfilledLeaveDaysEditedTR
                          : classes.requestedLeaveDays
                }
              >
                {data?.requestedLeaveDays?.toLocaleString()}
              </Box>
            </Box>
            <Box
              className={classes.leaveTooltipLeaveTitleLine}
              width={`${fulfilledLeavePercentage}%`}
            >
              <Box
                className={
                  data?.availableLeaveDays === 0 &&
                  data?.requestedLeaveDays === 0
                    ? classes.fulfilledLeaveDaysEditedTLTR
                    : classes.fulfilledLeaveDays
                }
              >
                {data?.fulfilledLeaveDays?.toLocaleString()}
              </Box>
            </Box>
            */}
          </>
        ) : (
          <Box>{t("MY_LEAVE_NO_LEAVE")}</Box>
        )}
      </Box>
    </Grid2>
  );
};

export default MyLeaveBarDashboard;
